import { FaStar } from "react-icons/fa";
import { Link } from "react-router-dom";
import Details from "./Details";

const ReviewsCard = ({ imageUrls, title }) => {
  return (
    <div className="box-border grid grid-cols-5 overflow-hidden rounded-lg border border-lightGray">
      <picture className="aspect-square">
        <img
          src={imageUrls[0] || "https://via.placeholder.com/150"}
          alt=""
          className="aspect-square w-full"
        />
      </picture>

      <div className="col-span-3 flex grow flex-col items-start justify-between px-8 pt-8 pb-10">
        <div className="flex flex-col">
          <Link to="/auctionlisting">
            <h3 className="mb-7 font-pop text-2xl font-bold text-darkGreen">
              {title || "Buz Plumbing"}
            </h3>
          </Link>
          <p className=" mb-2.5 w-4/5 font-pop text-sm font-normal text-cardSecondaryColor">
            Lorem ipsum dolor sit amet consectetur. Habitant magna et volutpat
            consectetur. Diam vestibulum rutrum odio amet massa nibh eget
            tellus.
          </p>
          <div className="flex items-center">
            {new Array(5).fill(0).map((_, index) => (
              <FaStar className="text-yellow" />
            ))}
          </div>
          <p className="mt-4 font-pop text-base font-medium text-darkGreen">
            07 Apr 2022
          </p>
        </div>
      </div>
      <Details itemType={"Review"} />
    </div>
  );
};

export default ReviewsCard;
